import {
  cta_buttonSecondaryBackground,
  cta_buttonSecondaryBackgroundHover,
  cta_buttonSecondaryBorder,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(1)};

  .thumbnail {
    height: ${spacing(10)};
    width: ${spacing(10)};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
    border-radius: ${spacing(1)};
    box-shadow: 0 0.8px 2px 0 rgba(0, 0, 0, 0.1);
    background: url(<path-to-image>) lightgray 50% / cover no-repeat;

    &.pdf {
      outline: 1px solid ${cta_buttonSecondaryBorder};
      background-color: ${cta_buttonSecondaryBackground};

      &:hover {
        background-color: ${cta_buttonSecondaryBackgroundHover};
      }
    }
  }
`
